export default __webpack_public_path__ + "static/media/product-page4.b86b1cc3.png";